import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-confirmation',
  templateUrl: './dialog-confirmation.component.html',
  styleUrls: ['./dialog-confirmation.component.scss']
})
export class DialogConfirmationComponent implements OnInit {

  public message: string = "";
  public askForConfirmation: boolean = true;
  public title: string = $localize `Are you sure?`;
  constructor(@Inject(MAT_DIALOG_DATA) public data: {message: string, askForConfirmation?: boolean, title?: string}) {
    this.message = data.message;
    if (data.title !== undefined){
      this.title = data.title;
    }
    if (data.askForConfirmation !== undefined){
      this.askForConfirmation = data.askForConfirmation;
    }
  }

  ngOnInit() {
  }

}
